import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'ramda';
import CSVUpload from '../../tc-ui/csv-upload/csv-upload-container';
import ExampleCSVUpload from '../../../../www/images/ex-csv-upload-contracting.png';

const UploadFile = props => {
  const {
    updateMMPartnerProp,
  } = props;
  const MMPartnerReducer = isEmpty(props.MMPartnerReducer2) ? props.MMPartnerReducer : props.MMPartnerReducer2; // fallback to reducer
  return (
    <div>
      <CSVUpload
        onCompleteFunc={successfulRows => {
          updateMMPartnerProp({
            showUploadFileDialog: false,
            partnersToSendTo: MMPartnerReducer.partnersToSendTo.concat(successfulRows),
            showSelectMethod: false,
            showReview: true,
          });
        }}
        showFailedSection
        open={MMPartnerReducer.showUploadFileDialog}
        onRequestClose={() => updateMMPartnerProp({ showUploadFileDialog: false })}
        dialogTitle={'Upload A File'}
        note={
          <div>
            The CSV or Excel file must have the following layout: <b>Company Name (optional), Email (required)</b>. Example format:
            <br/><br/>
            <img src={ExampleCSVUpload} width={500} />
          </div>
        }
        dropzoneText={'Drag and drop your CSV or Excel file here or click inside to choose a file from your computer.'}
        headers={[
          {
            headerTitle: 'companyName',
            required: false,
          },
          {
            headerTitle: 'email',
            required: true,
          },
        ]}
      />
    </div>
  );
};

UploadFile.propTypes = {
  updateMMPartnerProp: PropTypes.func,
  MMPartnerReducer: PropTypes.object,
  MMPartnerReducer2: PropTypes.object,
};

UploadFile.defaultProps = {
  MMPartnerReducer2: {},
};


const mapStateToProps = ({ marketingMaterials }) => ({
  MMPartnerReducer: marketingMaterials.partnerReducer.toJS(),
});

export default connect(mapStateToProps)(UploadFile);



// WEBPACK FOOTER //
// ./src/app/components/marketing-materials/send-to-partners/upload-file.jsx